import React, { useState } from 'react'
import Select from "react-select";
import { useNavigate } from "react-router-dom";

function ItemProducts() {
  const navigate = useNavigate();

  const [cardData] = useState([
    {
      name: 'Shisha'
    },
    {
      name: 'Burger'
    },
    {
      name: 'Sweet'
    },
    {
      name: 'Pakage 28'
    },
    {
      name: 'Pakage 15'
    },
    {
      name: 'Pakage 19'
    },
  ])

  return (

    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">

        <div>
          <h1 className="text-[#7B20C7] text-2xl font-semibold pt-5 pb-2">Products</h1>
        </div>
        <button
          className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-3 ease-linear transition-all duration-150 text-center w-fit"
          type="button"
          onClick={() => navigate(-1)}
        >
          Back To Category
        </button>

        <div>
          <label htmlFor="" className='text-xs font-semibold'>Category</label>
          <div className="mb-4 pt-0 w-1/3">
            <Select type="text" placeholder="Select"
              className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
              required />
          </div>
        </div>

        <div className="flex flex-wrap gap-6">
          {cardData &&
            cardData.map((data) => (

              <div className="border-solid border-2 border-[#7B20C7] cursor-pointer rounded-2xl w-36 hover:transition-all hover:bg-[#7B20C7] group ">

                <input type='checkbox' className="ms-28 cursor-pointer">

                </input>

                <h1 className="flex justify-center align-middle pb-6   text-md font-semibold group-hover:text-white ">{data.name}</h1>

              </div>

            ))}
        </div>



        <span className="w-full bg-[#7B20C7] h-1 my-2 mt-8 inline-block"></span>
        <div className="flex gap-2">
          <button
            className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
            type="submit">
            Submit
          </button>

        </div>
      </div>
    </main>
  )
}

export default ItemProducts
